require("prismjs/themes/prism.css")
require("./src/styles/prism-theme.css")